import Speech from "./Speech"

const App = () => {
  return (
    <div>
      <Speech/>
    </div>
  )
}

export default App
